import React, { Component } from "react";
const style = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    cursor: "pointer"
  },
  box: {
    backgroundColor: "#b5b5b6",
    borderRadius: "20px",
    height: "120px",
    width: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    boxSizing: "border-box"
    // border: "5px solid #00b894"
  },
  caption: {
    fontSize: "16px",
    color: "#444445"
  },
  cross: {
    position: "absolute",
    margin: "0px",
    top: "5px",
    right: "8px",
    fontSize: "18px",
    cursor: "pointer"
  },
  image: {
    maxWidth: "100px"
  },
  selectStyle: {
    position: "absolute",
    margin: "0px",
    top: "5px",
    right: "8px",
    height: "25px",
    width: "25px",
    borderRadius: "100%"
  }
};
class AmenityBox extends Component {
  state = {
    selected: false
  };
  selectToggle = () => {
    this.setState({
      ...this.state,
      selected: !this.state.selected
    });
  };
  render() {
    const selected = this.props.isPrimaryAmenity ? this.props.selected : this.state.selected
    return (
      <div
        style={style.wrapper}
        onClick={e => {
          if (this.props.onClick) {
            this.props.onClick();
            if (this.props.source) this.selectToggle();
          }
        }}
      >
        <div
          style={
            selected ? { ...style.box, border: "5px solid #00b894" } : style.box
          }
        >
          {this.props.edit ? (
            <p style={style.cross} onClick={this.props.onXClick}>
              X
            </p>
          ) : (
            ""
          )}
          {this.props.source ? (
            <img src={this.props.source} style={style.image} alt="amenity" />
          ) : (
            <h1
              style={{
                fontFamily: "monospace",
                fontSize: "80px",
                color: "#444546"
              }}
            >
              +
            </h1>
          )}
        </div>
        <p style={style.caption}>{this.props.label}</p>
      </div>
    );
  }
}

export default AmenityBox;
